import { ModulePlaceholder } from "@/components/modules/ModulePlaceholder";

const Compliance = () => {
  return <ModulePlaceholder moduleKey="compliance" />;
};

export default Compliance;
